import ReviewsVertical from "./ReviewsVertical.page";

export default ReviewsVertical;
